import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { ReactComponent as Warning } from "assets/Warning.svg";
import { useTranslation } from "react-i18next";

const SaveConfirmModal = ({ open, onClose, onLeaveChanges, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="template-download-warning"
      aria-describedby="template-download-warning-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "30px 10px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
          outline: "none",
        }}
      >
        <Box sx={{ mb: "-30px" }}>
          <Warning
            style={{ width: "161px", height: "149px", margin: "0 auto" }}
          />
        </Box>

        <Typography
          id="template-download-warning-description"
          sx={{
            color: "#333",
            fontSize: "16px",
            lineHeight: 1.5,
            fontFamily: "Montserrat",
            fontWeight: 500,
            maxWidth: "300px",
            margin: "0 auto",
          }}
        >
          {t("promptActionNotification.modalMsg")}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Box
            sx={{
              display: "flex",
              width: "80%",
              justifyContent: "space-around",
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                backgroundColor: "gray",
                color: "white",
                borderRadius: "10px",
                padding: "8px 16px",
                fontSize: "15px",
                fontWeight: "500",
                textDecoration: "",
                fontFamily: "Montserrat",
                minWidth: "94px",
                "&:hover": {
                  backgroundColor: "darkgray",
                },
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("questionnaireSetup.cancel")}
            </Button>
            <Button
              onClick={onLeaveChanges}
              sx={{
                backgroundColor: "gray",
                color: "white",
                borderRadius: "10px",
                padding: "8px 16px",
                fontSize: "15px",
                fontWeight: "500",
                textDecoration: "",
                fontFamily: "Montserrat",
                minWidth: "94px",
                "&:hover": {
                  backgroundColor: "darkgray",
                },
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("promptActionNotification.no")}
            </Button>

            <Button
              onClick={onConfirm}
              sx={{
                backgroundColor: "#EF7D00",
                color: "white",
                borderRadius: "10px",
                padding: "8px 16px",
                fontSize: "15px",
                fontWeight: "500",
                fontFamily: "Montserrat",
                minWidth: "94px",
                "&:hover": {
                  backgroundColor: "#d66d00",
                },
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("promptActionNotification.yes")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default SaveConfirmModal;
